import { goesPaths } from "./goes-paths";

const GOES = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="goes-svg"
    >
      {goesPaths}
    </svg>
  );
};
export default GOES;
